import { render, staticRenderFns } from "./VToken.vue?vue&type=template&id=2350448e&scoped=true"
import script from "./VToken.vue?vue&type=script&lang=js"
export * from "./VToken.vue?vue&type=script&lang=js"
import style0 from "./VToken.vue?vue&type=style&index=0&id=2350448e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2350448e",
  null
  
)

export default component.exports